// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"26":"66424494d8964926984f","751":"fe3ff4a410b1965717f6"}[chunkId] + ".js";
};